import { Controller } from 'stimulus';

// This controller is used to detect when user want to quit the current page,
// in order to show them a popup via stimulus controller UI--modals--component
// How to use it:
//
// div data-controller="exit-intent" data-exit-intent-modal-trigger-value="my-modal-trigger"
//   = render UI::Modals::Component.new(trigger_name: "my-modal-trigger", ...)

export default class extends Controller {
  static values = {
    modalTrigger: String
  }

  connect() {
    this.handler = this.onMouseOut.bind(this);
    document.addEventListener('mouseout', this.handler);
  }

  disconnect() {
    document.removeEventListener('mouseout', this.handler);
  }

  onMouseOut(event) {
    // On détecte la position de la souris qui sort du viewport (ie. qui veut fermer l'onglet)
    if (event.relatedTarget === null && event.clientY <= 0) {
      this.showModal();
    }
  }

  showModal() {
    const modalElement = document.querySelector(`[data-controller="UI--modals--component"][data-trigger-name="${this.modalTriggerValue}"]`);
    if (modalElement) {
      const controller = this.application.getControllerForElementAndIdentifier(modalElement, 'UI--modals--component');
      if (controller) {
        controller.open();
        window.souscriptionPopin?.('affichage');
        // Ne pas montrer la popup plus d'une fois par affichage de page
        this.disconnect();
      }
    }
  }
}
